<template>
  <div
    class="state-identify-radio-button"
    :class="{disabled:disabled}"
  >
    <p class="state-identify-radio-button_title">
      {{ $t(title) }}<span>*</span>
    </p>
    <div class="radio-button input small">
      <div class="radio-button-container">
        <label for="factory">
          <input
            id="factory"
            v-model="identifySelect"
            type="radio"
            name="identify"
            value="factory"
            checked
          >
          <i class="icon-radio-button-unchecked radio-button-container__icon" />
          <i class=" icon-radio-button-checked radio-button-container__icon" />
          <p class="input-text">
            {{ $t(factoryTitle) }}
          </p>
          <div
            class="input"
            style="width:100%"
          />
        </label>
        <slot name="factory" />
      </div>
      <div class="radio-button-container">
        <label for="taker">
          <input
            id="taker"
            v-model="identifySelect"
            type="radio"
            name="identify"
            value="taker"
          >
          <i class="icon-radio-button-unchecked radio-button-container__icon" />
          <i class=" icon-radio-button-checked radio-button-container__icon" />
          <p class="input-text">
            {{ takerTitle }}
          </p>
          <div
            class="input"
            style="width:100%"
          />
        </label>
        <slot name="taker" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StateIdentifyRadioButton",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    takerTitle: {
      type: String,
      default: '人員',
    },
    factoryTitle: {
      type: String,
      default: '工廠',
    },
  },
  data: () => ({
    identifySelect: "factory",
    remindDate: "",
  }),
  computed: {},
  watch: {
    identifySelect() {
      this.setIndentify();
    },
    value() {
      this.identifySelect = this.value;
    },
  },
  mounted() {
    this.identifySelect = this.value;
  },
  methods: {
    setIndentify() {
      this.$emit("input", this.identifySelect);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/state-identify-radio-button";
</style>